<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M4.667 7.334v17.333h22.667V7.334H4.667zm-.333-2c-.92 0-1.667.746-1.667 1.667v18c0 .92.746 1.666 1.667 1.666h23.333c.92 0 1.667-.746 1.667-1.666V7c0-.92-.747-1.667-1.667-1.667H4.334z" clip-rule="evenodd"/></svg>
</template>

<script>
export default {
  name: 'symbolsRectangle'
}
</script>
